import { useId } from 'react';
import { selectUserProjectDefaultSenderEmail } from 'core/userContext';
import { useDispatch, useSelector } from 'react-redux';
import { PrimaryButton } from 'ui/button';
import { ModalFooter, ModalBody, ModalHeader, Modal, MODAL_SIZES } from 'ui/modal';
import { DefaultSenderEmailForm } from './DefaultSenderEmailForm';
import type { DefaultSenderModalProps } from '../types';
import { setDefaultSenderRequest } from '../actions';
import {
  DefaultSenderEmailFormProvider,
  DefaultSenderEmailFormContextType,
} from '../contexts/DefaultSenderEmailFormProvider';

export const AuthedEmailSetDefaultSenderModal = ({ onClose }: DefaultSenderModalProps) => {
  const dispatch = useDispatch();
  const id = useId();
  const formId = useId();
  const defaultSenderName = useSelector(selectUserProjectDefaultSenderEmail);

  const onSubmit = ({ senderName }: DefaultSenderEmailFormContextType) => {
    if (!senderName) {
      return;
    }

    dispatch(setDefaultSenderRequest({ email: senderName }));
    onClose();
  };

  return (
    <DefaultSenderEmailFormProvider defaultValues={{ senderName: defaultSenderName }}>
      <Modal onClose={onClose} isModalOpen id={id} size={MODAL_SIZES.SMALL}>
        <ModalHeader>Set the new default email sender</ModalHeader>
        <ModalBody>
          <DefaultSenderEmailForm formId={formId} onSubmit={onSubmit} />
        </ModalBody>
        <ModalFooter onClose={onClose}>
          <PrimaryButton type="submit" form={formId} data-test="default-sender-form-submit-button">
            Update default sender
          </PrimaryButton>
        </ModalFooter>
      </Modal>
    </DefaultSenderEmailFormProvider>
  );
};
